import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import CentralDaMarcaBffService from '@/services/central-da-marca-bff.service'
import type { PageDTO } from '@/data/dto/page.dto'
import type { PageStoreContract } from '@/data/store/page.store.contract'

type BasicState<T> = {
  loading: boolean
  data: T | null
  error: string | null
}

type LocalState = BasicState<PageDTO>

@Module({
  name: 'VerbalIdentityPageStore',
  dynamic: true,
  namespaced: true,
  store
})
export class VerbalIdentityPageStore extends VuexModule implements PageStoreContract {
  bffService = new CentralDaMarcaBffService()

  paginationLimit = 10

  _state: LocalState = {
    loading: false,
    error: null,
    data: null
  }

  get isLoading(): boolean {
    return this._state.loading
  }

  get all(): PageDTO | null {
    return this._state.data
  }

  @Mutation
  updateVerbalIdentityPageState(payload: Partial<LocalState>): void {
    this._state = {
      ...this._state,
      ...payload
    }
  }

  @Action
  async getDataPage(): Promise<void> {
    this.updateVerbalIdentityPageState({
      loading: true,
      error: null
    })

    try {
      const response = await this.bffService.getVerbalIdentityPageByTitle()
      this.updateVerbalIdentityPageState({ data: response })
    } catch (error: any) {
      this.updateVerbalIdentityPageState({
        error: error?.message
      })
    } finally {
      this.updateVerbalIdentityPageState({
        loading: false
      })
    }
  }
}
